import { ColumnDef } from '@tanstack/react-table';
import i18n from 'i18next';

import { Tag } from '@/components/generic';
import { TableData } from '@/types';

export const getPlayerReleaseColumns: () => ColumnDef<TableData>[] = () => [
  {
    id: 'version',
    accessorKey: 'version',
    header: i18n.t('version', { ns: 'common' })
  },
  {
    id: 'url',
    accessorKey: 'url',
    header: i18n.t('url', { ns: 'common' })
  },
  {
    id: 'isPublic',
    header: i18n.t('status', { ns: 'common' }),
    accessorKey: 'isPublic',
    cell: (props) => <Tag value={props.getValue() ? 'Published' : 'Drafted'} />
  }
];
